import { LancamentoAgrupado } from "./lancamento-agrupado";
import { LancamentoPrincipal } from "./lancamento-principal";

export class Lancamento {
  id: number;
  data: Date;
  descricao: string | null;
  tipoLancamentoId: number;
  valor: number;
  valorX100: number;
  conciliado: boolean;
}

export function isLancamentoPrincipal(obj: any): obj is LancamentoPrincipal {
  return obj && 'ehAgrupador' in obj && 'lancamentosAgrupados' in obj;
}

export function isLancamentoAgrupado(obj: any): obj is LancamentoAgrupado {
  return obj && 'lancamentoPrincipalId' in obj;
}